import { render, staticRenderFns } from "./DefaultSettings.vue?vue&type=template&id=f936d7ca&scoped=true&"
import script from "./DefaultSettings.vue?vue&type=script&lang=ts&"
export * from "./DefaultSettings.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultSettings.vue?vue&type=style&index=0&id=f936d7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f936d7ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VTreeview})
